export default __webpack_public_path__ + "static/media/logoMinified.6ae830b4.svg";